<!-- <app-header (go-back)="reloadApp()" [title]="getToolbarTitle()"></app-header> -->

<div class="container">
  <h1 class="thanksMessage" *ngIf="feedbackSubmitted" i18n>Thank you for your feedback.</h1>
  <button mat-button *ngIf="feedbackSubmitted" (click)="feedbackSubmitted = false" i18n>Forgot something? Show feedback form again.</button>
  <div *ngIf="!feedbackSubmitted">
  <h2 style="margin-bottom: 5px;" i18n>Do you have time to give feedback?</h2>
  <h4 style="margin-top: 0" i18n>Your feedback would help us improve the app further.</h4>
    <mat-list-item>
      <h4 class="feedback-title" i18n>This tool was helpful.</h4>
    <mat-radio-group aria-label="Select an option" i18n-aria-label name="wasHelpful" [(ngModel)]="feedback.wasHelpful" required>
      <mat-radio-button value="1" i18n>Strongly agree</mat-radio-button>
      <mat-radio-button value="2" i18n>Agree</mat-radio-button>
      <mat-radio-button value="3" i18n>Neutral</mat-radio-button>
      <mat-radio-button value="4" i18n>Disagree</mat-radio-button>
      <mat-radio-button value="5" i18n>Strongly disagree</mat-radio-button>
    </mat-radio-group>
  </mat-list-item>
    <mat-list-item>
      <h4 class="feedback-title" i18n>The user interface was good.</h4>
    <mat-radio-group aria-label="Select an option" name="uiIsGood" [(ngModel)]="feedback.uiIsGood">
      <mat-radio-button value="1" i18n>Strongly agree</mat-radio-button>
      <mat-radio-button value="2" i18n>Agree</mat-radio-button>
      <mat-radio-button value="3" i18n>Neutral</mat-radio-button>
      <mat-radio-button value="4" i18n>Disagree</mat-radio-button>
      <mat-radio-button value="5" i18n>Strongly disagree</mat-radio-button>
    </mat-radio-group>
  </mat-list-item>
    <mat-list-item>
      <h4 class="feedback-title" i18n>Would you use this tool?</h4>
    <mat-radio-group aria-label="Select an option" name="iWillUseIt" [(ngModel)]="feedback.iWillUseIt">
      <mat-radio-button value="yes" i18n>Yes</mat-radio-button>
      <mat-radio-button value="no" i18n>No</mat-radio-button>
    </mat-radio-group>
  </mat-list-item>
  <mat-list-item>
    <h4 class="feedback-title" i18n>Did you run into any major problems?</h4>
    <p i18n>If yes, please provide some details in the text form below.</p>
      <mat-radio-group aria-label="Select an option" name="majorProblems" [(ngModel)]="feedback.majorProblems" (change)="fileExpansion.expanded = fileExpansion.expanded || feedback.majorProblems">
        <mat-radio-button [value]="true" i18n>Yes</mat-radio-button>
        <mat-radio-button [value]="false" i18n>No</mat-radio-button>
      </mat-radio-group>
  </mat-list-item>  
  <p *ngIf="feedback.majorProblems" style="font-weight: 400;" i18n>
    If you had compatibility problems with your file, we would greatly appreciate if you could provide it, so we can fix the issue.
  </p>
  <br *ngIf="!feedback.majorProblems"/>
  <mat-accordion>
    <mat-expansion-panel #fileExpansion>
      <mat-expansion-panel-header>
        <mat-panel-title i18n>
         Upload files
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-checkbox [disabled]="!isCurrentFileAvailabe()" [(ngModel)]="uploadCurrentFile" i18n>Upload the current file (<b>{{getCurrentFilename()}}</b>)</mat-checkbox>
      <br />
      <mat-checkbox #otherFiles i18n>Upload additional/other files</mat-checkbox>
      <br />
      <input type="file" name="file" multiple #fileSelector (change)="feedback.files = fileSelector.files" [disabled]="!otherFiles.checked" title="Other files"  i18n-title> 
    <p i18n>Uploaded files will be strictly used only for testing and improving this tool.</p>
    </mat-expansion-panel>
  </mat-accordion>

    <mat-list-item>
      <h4 class="feedback-title" i18n>Additional comments</h4>
    <mat-form-field class="full-width">
      <textarea matInput placeholder="Leave a comment"  i18n-placeholder name="suggestions" [(ngModel)]="feedback.suggestions"></textarea>
    </mat-form-field>
  </mat-list-item>  
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <button mat-flat-button color="accent" [disabled]="!isValid() || feedbackSubmitted || loading" (click)="submitFeedback()" i18n>Send feedback</button>
</div>
</div>  
